import React from "react";
import { Skeleton } from "@material-ui/lab";

export function HouseDetailsSkeleton() {
  const JSX = (
    <>
      <div className="row mt-4">
        <div className="col-12 house-detials-container">
          <Skeleton animation="wave" variant="react" />
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <label className="form-label">
                  <Skeleton animation="wave" variant="text" width={100} />
                </label>
                <Skeleton animation="wave" height={100} variant="rect" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label className="form-label mb-0">
                  <Skeleton animation="wave" variant="text" width={100} />
                </label>
                <Skeleton animation="wave" height={40} variant="rect" />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label className="form-label mb-0">
                  <Skeleton animation="wave" variant="text" width={100} />
                </label>
                <Skeleton animation="wave" height={40} variant="rect" />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label className="form-label mb-0">
                  <Skeleton animation="wave" variant="text" width={100} />
                </label>
                <Skeleton animation="wave" height={40} variant="rect" />
              </div>
            </div>
          </div>
          <div className="row mb-2 floor-basic-info">
            <div className="col-sm-2 col-md-3 col-lg-4 col-xl-3">
              <div className="form-group">
                <label className="form-label">
                  <Skeleton animation="wave" variant="text" width={100} />
                </label>
                <div className="floor-no w-20">
                  <Skeleton animation="wave" height={40} variant="rect" />
                </div>
                <label className="current_floor-error error-text m-0"></label>
              </div>
            </div>
            <div className="col-sm-2 col-md-3 col-lg-4 col-xl-6">
              <div className="form-group">
                <label className="form-label">
                  <Skeleton animation="wave" variant="text" width={100} />
                </label>

                <div>
                  <Skeleton animation="wave" height={40} variant="rect" />
                </div>
              </div>
            </div>
            <div className="col-sm-2 col-md-12 col-lg-12 col-xl-12">
              <div className="form-group">
                <label className="form-label old-house-dist-label">
                  <Skeleton animation="wave" variant="text" width={100} />
                </label>
                <div className="d-flex align-items-center position-relative">
                  <div id="existingHouseSlider" className="slider w-100">
                    <Skeleton animation="wave" height={35} variant="rect" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  return JSX;
}
